import { IGroupByEpicsToggleAction } from './types';
import { AT_GROUP_BY_EPICS_TOGGLE } from './constants';

export const groupByEpicsToggleAction = (
): IGroupByEpicsToggleAction => ({
        type: AT_GROUP_BY_EPICS_TOGGLE
    }
);
